export const ImagesListName = ({ titleType, index, name }: Props) => {
  const title = titleType === 'attachment' ? 'تکمیلی' : 'مدارک';
  return name ?? `${title} ${index + 1}`;
};

type Props = TitleWhitCounter | NormalTitle;

type TitleWhitCounter = {
  titleType: 'attachment' | 'document';
  index: number;
  name?: undefined;
};
type NormalTitle = {
  titleType?: undefined;
  index?: undefined;
  name: string;
};
